// ============================================================
// HERBALVIT-PLATZHALTER
// ============================================================
// ATTENZIONE: questo NON e' il popup ufficiale di Herbalife.
//
// La Regola 6.5 DE chiede un popup "von Herbalife zur Verfuegung gestellt und
// nicht geaendert". Questo file e' una ricostruzione provvisoria, creata il
// 23/8/2026 su richiesta di Antonio per poter vedere il sito completo mentre
// Francesco richiede l'originale a MPCGSA@herbalife.com.
//
// NON PUBBLICARE IL NEGOZIO CON QUESTO FILE.
// scan_residui_uk.py segnala "HERBALVIT-PLATZHALTER" come occorrenza bloccante
// apposta. Il blocco cade da solo quando installa_popup_de.py sovrascrive
// questo file con lo zip ufficiale.
// ============================================================

var varHTML = `<style>
#herbalifepopup p, #herbalifepopup h2{
  font-family:'Helvetica','Arial',sans-serif !important; color:#6c6d70 !important;
}
.herbalife-popup{
  position:fixed !important; top:0 !important; right:0 !important;
  bottom:0 !important; left:0 !important; z-index:999999 !important;
  text-align:center !important; display:none; color:#6c6d70 !important;
}
.herbalife-bg{
  position:absolute !important; top:0 !important; right:0 !important;
  bottom:0 !important; left:0 !important; background:#000 !important;
  opacity:.9 !important; z-index:999998 !important;
}
.herbalife-wrap{
  min-width:400px !important; height:auto !important; max-height:100% !important;
  position:absolute !important; top:50% !important; left:50% !important;
  z-index:999999 !important; transform:translate(-50%,-50%) !important;
  margin:0 auto !important; overflow-y:auto !important;
}
.herbalife-content{
  position:relative !important; display:inline-block !important;
  padding:15px !important; background:#fff !important;
}
.herbalife-info{
  position:relative !important; float:left !important; padding:15px !important;
  border:3px solid #7ac142 !important;
}
.herbalife-info h2{
  width:calc(100% - 2rem) !important; margin:0 0 15px 0 !important;
  padding:0 !important; font-size:18px !important; line-height:1em !important;
  font-weight:bold !important; color:#6c6d70 !important;
}
.herbalife-info .herbalife-close{
  position:absolute !important; top:5px !important; right:10px !important;
  background:#7ac142 !important; border-radius:50% !important;
  font-size:12px !important; font-weight:bold; color:#fff !important;
  padding:8px !important; text-decoration:none !important;
  text-align:center !important; cursor:pointer !important; line-height:8px;
}
.herbalife-info .herbalife-close:hover{ background:#6c6d70 !important; }
.herbalife-info .herbalife-row{ position:relative !important; float:left !important; }
.herbalife-info .left-col{ width:60% !important; position:relative !important; float:left !important; }
.herbalife-info .left-col.border{ width:calc(60% - 16px) !important; padding:0 15px 0 0 !important; }
.herbalife-info .right-col{ width:40% !important; position:relative !important; float:left !important; }
.herbalife-info .right-col.border{
  width:calc(40% - 15px) !important; padding:0 0 0 15px !important;
  border-left:1px solid #7ac142 !important;
}
.herbalife-info p a{ font-weight:bold; text-decoration:none; color:#6c6d70 !important; }
p.para-lead{ font-size:1.2em; margin:.75em; }
.clear{ height:0 !important; line-height:0 !important; clear:both !important; }

@media (min-width:768px){ .herbalife-wrap{ min-width:768px !important; } }
@media (min-width:992px){ .herbalife-wrap{ min-width:850px !important; } }
@media (max-width:767px){
  /* NB: qui l'originale UK aveva .herbalife-popup{display:none!important}.
     Non si replica: la Regola 6.5 vuole il popup a ogni visita, su ogni
     schermo. Sotto i 768px le due colonne si impilano, e basta. */
  .herbalife-wrap{ min-width:90% !important; }
  .herbalife-info .left-col,
  .herbalife-info .right-col,
  .herbalife-info .left-col.border,
  .herbalife-info .right-col.border{
    width:100% !important; margin:0 0 10px 0 !important;
    padding:0 !important; border:0 !important;
  }
  .herbalife-info .left-col.border{ text-align:center !important; }
  .herbalife-info h2{ font-size:.95em !important; line-height:1.2em !important; }
  p.para-lead{ font-size:1em !important; }
}
</style>
<div class="herbalife-popup" id="wc_herba_popup">
  <div class="herbalife-bg">&nbsp;</div>
  <div class="herbalife-wrap">
    <div class="herbalife-content">
      <div class="herbalife-info">
        <a class="herbalife-close" href="#" onclick="wcHidePopUp(); return false;">x</a>
        <p class="para-lead">Diese Website wird von folgendem Herbalife Selbst&auml;ndigen Berater betrieben: Francesco Dibattista</p>
        <div class="herbalife-row">
          <div class="left-col border">
            <h2>SIE SIND BEREITS KUNDIN ODER KUNDE?</h2>
            <p>Die pers&ouml;nliche Betreuung durch Ihren Berater ist ein wesentlicher Teil des Herbalife Konzepts. Wenn Francesco Dibattista nicht Ihr pers&ouml;nlicher Berater ist, empfehlen wir Ihnen, Ihre Produkte weiterhin dort zu beziehen. Andernfalls <a href="#" onclick="wcHidePopUp(); return false;">klicken Sie hier</a>, um auf dieser Website fortzufahren.</p>
          </div>
          <div class="right-col border">
            <h2>SIE SIND SELBST HERBALIFE BERATER?</h2>
            <p>Um &uuml;ber Ihr eigenes Konto zu bestellen und die Gutschrift zu erhalten, besuchen Sie bitte <a href="https://www.myherbalife.com/de-DE">myherbalife.com</a></p>
          </div>
        </div>
        <div class="clear">&nbsp;</div>
      </div>
    </div>
  </div>
</div>`;

document.getElementById('herbalifepopup').innerHTML = varHTML;

// Cookie di SESSIONE: la guida tedesca dice "beim Oeffnen sowie bei jedem
// Besuch", quindi il popup deve tornare a ogni nuova visita. Senza 'expires'
// il cookie muore alla chiusura del browser.
function wcSetCookie(cname, cvalue) {
  document.cookie = cname + "=" + cvalue + ";path=/";
}

function wcGetCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') { c = c.substring(1); }
    if (c.indexOf(name) === 0) { return c.substring(name.length, c.length); }
  }
  return "";
}

function wcHidePopUp() {
  var el = document.getElementById('wc_herba_popup');
  if (el) { el.style.display = 'none'; }
}

if (wcGetCookie('wc_popup_herba') != "shown") {
  document.getElementById('wc_herba_popup').style.display = 'block';
  wcSetCookie('wc_popup_herba', 'shown');
}
